module.exports = __webpack_public_path__ + "img/37.acbaced8.jpg";